import React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import normalize from 'common/Normalize';
import { AppView, rem } from 'design-system';
import Text from 'design-system/Text';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useMarginBottom } from 'hooks/useMarginBottom';
import QuoteInformation from '../components/QuoteInformation';
// TODO this should use a flatlist
const QuoteFurtherInformation = withAnimatedNavigationHeader(({ route, scrollY }) => {
    const renderHeader = (typeEnergy) => (<View style={styles.titleRow} key={typeEnergy}>
          <Text Text-16 style={styles.detailsTitle}>
            {typeEnergy}
          </Text>
          <Text Text-16 style={styles.detailsTitle}>
            Existing tariff
          </Text>
          <Text Text-16 style={styles.detailsTitle}>
            New tariff
          </Text>
        </View>);
    const renderTariffInformationGas = () => {
        const { gas } = route.params.comparison;
        if (!gas || !gas.length) {
            return null;
        }
        const details = [];
        details.push(renderHeader('Gas'));
        for (let index = 0; index < gas.length; index++) {
            if (gas[index].new) {
                details.push(<QuoteInformation key={gas[index].name} title={gas[index].name} text={gas[index].existing} secondText={gas[index].new} styleTitle={styles.titleInformation} styleSummary={styles.information}/>);
            }
        }
        return details;
    };
    const renderTariffInformationElectricity = () => {
        const { electricity } = route.params.comparison;
        if (!electricity || !electricity.length) {
            return null;
        }
        const details = [];
        details.push(renderHeader('Electricity'));
        for (let index = 0; index < electricity.length; index++) {
            if (electricity[index].new) {
                details.push(<QuoteInformation key={electricity[index].name} title={electricity[index].name} text={electricity[index].existing} secondText={electricity[index].new} styleTitle={styles.titleInformation} styleSummary={styles.information}/>);
            }
        }
        return details;
    };
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    const paddingBottom = useMarginBottom('paddingBottom', rem(16), styles.wrap);
    return (<AppView type="primary">
          <Animated.ScrollView contentContainerStyle={paddingBottom} onScroll={scrollHandler} scrollEventThrottle={16}>
            {renderTariffInformationGas()}
            {renderTariffInformationElectricity()}
          </Animated.ScrollView>
        </AppView>);
}, ({ colors }) => ({
    title: 'Comparison',
    headerColorOutputRange: [
        colors.background.light,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    wrap: {
        marginTop: rem(16),
        paddingHorizontal: rem(16),
    },
    titleRow: {
        flexDirection: 'row',
        columnGap: 10,
    },
    detailsTitle: {
        flexGrow: 1,
        flexBasis: 3,
        marginVertical: 10,
    },
    titleInformation: {
        flexGrow: 1,
        flexBasis: 3,
        fontSize: normalize(11.2),
        lineHeight: normalize(11.2) * 1.1,
    },
    information: {
        flexGrow: 1,
        flexBasis: 3,
        fontSize: normalize(11.2),
        lineHeight: normalize(11.2) * 1.1,
    },
});
export default QuoteFurtherInformation;
